<div class="top-buffer clearfix">
  <div #ideaCanvas class="idea-board"></div>
  <ng-container *ngFor="let idea of session.data.ideas; let i = index">
    <div
      ngDraggable
      *ngIf="idea.created_by === session.me._id"
      [position]="getPosition(idea, i)"
      [preventDefaultEvent]="true"
      [bounds]="ideaCanvas"
      [inBounds]="true"
      (endOffset)="ideaMoveEnd($event, idea, i)"
      class="draggable col-lg-2 idea-item-small">
      <app-idea-card-small
        (ideaAction)="openIdeaModal($event)"
        [idea]="idea"
        [session]="session"
        class="idea-card-small"
        [ngClass]="{ unpublished: !idea.published }"></app-idea-card-small>
    </div>
  </ng-container>
</div>
